import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IListingSortOption } from '@df/catalog-ui/listing/sort/listing-sort';
import { ListingSortComponentDef } from '@df/catalog-ui/listing/sort/listing-sort.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ProductListingDropdownComponent } from '../dropdown/listing-dropdown.component';
import { FilterExpandableComponent } from '../filter/filter-expandable.component';

@Component({
    selector: 'listing-sort',
    templateUrl: './listing-sort.html',
    imports: [TranslationModule, FilterExpandableComponent, ProductListingDropdownComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingSortComponent extends ListingSortComponentDef {
    @Input()
    openByDefault = false;

    protected sortBy(option: IListingSortOption) {
        this.sort.by(option);
        this.detectChanges();
    }
}
